export default "/_next/static/images/747c052a5e88f1d6105fd77fad480668.svg";